var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningYellowTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80918 38C1.41431 38 0.69802 37.1163 0.396426 36.5785C0.094833 36.0406 -0.319858 34.9648 0.396426 33.7353L17.5872 3.42154C18.3035 2.19208 19.3968 2 20 2C20.6032 2 21.7342 2.19208 22.4128 3.42154L39.6036 33.7353C40.3199 34.9648 39.9052 36.0406 39.6036 36.5785C39.302 37.1163 38.5857 38 37.1908 38H2.80918Z",
    fill: "#FFB600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6328 16.3857H17.8035L14.541 23.2592L19.1469 25.17L16.1243 31.9373L25.5279 22.7815L20.5862 21.4281L23.6328 16.3857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellowTriangle);
export default __webpack_public_path__ + "static/media/warningYellowTriangle.72c0ccef7e7e739eaf5af9706b7dd7f6.svg";
export { ForwardRef as ReactComponent };